module.exports = __webpack_public_path__ + "img/1085318.jpg";